import api from '@/utils/api';

export namespace SubmitListType {
  export interface Position {
    resume: string;
    classify: any;
    name: string;
    id: number;
  }

  export interface Datum {
    id: number;
    company: string;
    title: string;
    logoUrl: string;
    positions: Position[];
    infocity: string[];
    isExpired: boolean;
    is_official: number;
    web: string;
    active_time: string;
    expire_time: string;
  }
}

export async function fetchPositionList(params: { info_id: string }) {
  return api<API.Response<SubmitListType.Datum[]>>(`/exam/recommend-info`, {
    method: 'GET',
    params,
  });
}
